<template>
  <GmbControlColumn>
    <!-- FIXME without the v-if, the list of individuals doesn't get updated later!! Maybe bug with Section->hasDefaultContent -->
    <GmbSection
        v-if="individuals"
        :childCheckboxActivatedValues="individualIds"
        :childCheckboxAllValues="
        individuals
          ? individuals.map((individual) => individual.pk.toString())
          : []
      "
        :childControlKeywordObjs="IndividualKeywordObjs"
        :displayLevel="1"
        searchPlaceholder="Rechercher ville/code postal..."
        hasSearchField
        height="parent"
        lockHeader
        title="Liste d'individus"
        @child-checkbox-activated-values-changed="
        (newActivatedIndividualIds) =>
          $emit('activated-individuals-changed', newActivatedIndividualIds)
      "
    >
      <template #picto>
        <FdText colorTheme4 fa><i class="fas fa-users"/></FdText>
      </template>

      <template #infoSticker>
        <GmbSticker :text="individuals ? individuals.length : 0"/>
      </template>

      <template v-if="individuals.length !== 0">
        <GmbRow
            v-for="(individual, i) in individuals"
            :class="{ 'mt-2': i != 0 }"
            :controlValue="individual.pk.toString()"
            isCheckbox
            :key="i"
        >
          <FdText tag="span">{{
              individual.reference_id || "#" + individual.pk
            }}
          </FdText>
          <FdText v-if="individual.individual_email" tag="span">{{ individual.individual_email }}</FdText>
          <FdText
              v-if="individual.address || individual.postcode || individual.city"
              tag="span"
          >{{
              individual.address +
              "\n" +
              individual.postcode +
              " " +
              individual.city
            }}
          </FdText
          >
        </GmbRow>
      </template>

      <FdText v-else tag="span">Aucune donnée</FdText>
    </GmbSection>

    <template #controls>
      <b-button
          class="d-flex p-1 justify-content-center align-items-center text-size-reset rounded-1"
          variant="primary"
          @click="openModal('create-individual')"
      >
        <FdText fa><i class="fas fa-add"/></FdText>
        <FdText class="mx-2" tag="span">Nouveau</FdText>
      </b-button>
    </template>
  </GmbControlColumn>
</template>

<script>
import ModalEventBus from "@/modalEventBus.js";

import FdText from "@/flexdesign/Text";

import GmbControlColumn from "@/widgets/ControlColumn";
import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "GmbDataEditionIndividuals",

  components: {
    FdText,
    GmbControlColumn,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  props: {
    individualIds: Array,
    individuals: Array,
  },

  data() {
    return {};
  },

  computed: {

    IndividualKeywordObjs() {
      let keywordObjs = [];

      this.individuals.forEach((individual) => {
        keywordObjs.push({
          value: individual.pk.toString(),
          keywords: [individual.reference_id, individual.city, individual.postcode],
        });
      });

      return keywordObjs;
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    openModal(modalSlug) {
      ModalEventBus.$emit("gmb-open-modal", modalSlug);
    },
  },
};
</script>

<style lang="scss"></style>
